'use client'

// src/components/ui/RoundedElement/RoundedElement.classes.ts
var cornerConfig = {
  "top-left": {
    className: "absolute -top-0 ltr:-right-8 rtl:-left-8",
    viewBox: "0 0 56 24",
    path: "M32 24C32 10.7452 42.7452 0 56 0H0C13.2548 3.8658e-07 24 10.7452 24 24H32Z",
    width: "56",
    height: "24"
  },
  "top-right": {
    className: "absolute -top-0 ltr:-left-8 rtl:-right-8",
    viewBox: "0 0 56 24",
    path: "M32 24C32 10.7452 42.7452 0 56 0H0C13.2548 3.8658e-07 24 10.7452 24 24H32Z",
    width: "56",
    height: "24"
  },
  "bottom-left": {
    className: "absolute -bottom-0 ltr:-right-8 rtl:-left-8",
    viewBox: "0 0 56 24",
    path: "M32 0C32 13.2548 42.7452 24 56 24H0C13.2548 24 24 13.2548 24 0H32Z",
    width: "56",
    height: "24"
  },
  "bottom-right": {
    className: "absolute -bottom-0 ltr:-left-8 rtl:-right-8",
    viewBox: "0 0 56 24",
    path: "M32 0C32 13.2548 42.7452 24 56 24H0C13.2548 24 24 13.2548 24 0H32Z",
    width: "56",
    height: "24"
  },
  "left-top": {
    className: "absolute -top-8 ltr:-right-0 ltr:rotate-180 rtl:-left-0",
    viewBox: "0 0 24 56",
    path: "M24 24C10.7452 24 0 13.2548 0 0L0 56C3.8658e-07 42.7452 10.7452 32 24 32L24 24Z",
    width: "24",
    height: "56"
  },
  "left-bottom": {
    className: "absolute -bottom-8 ltr:-right-0 ltr:rotate-180 rtl:-left-0",
    viewBox: "0 0 24 56",
    path: "M24 24C10.7452 24 0 13.2548 0 0L0 56C3.8658e-07 42.7452 10.7452 32 24 32L24 24Z",
    width: "24",
    height: "56"
  },
  "right-top": {
    className: "absolute -top-8 ltr:-left-0 rtl:-right-0 rtl:rotate-180",
    viewBox: "0 0 24 56",
    path: "M24 24C10.7452 24 0 13.2548 0 0L0 56C3.8658e-07 42.7452 10.7452 32 24 32L24 24Z",
    width: "24",
    height: "56"
  },
  "right-bottom": {
    className: "absolute -bottom-8 ltr:-left-0 ltr:rotate-180 rtl:-right-0",
    viewBox: "0 0 24 56",
    path: "M0 24C13.2548 24 24 13.2548 24 0L24 56C24 42.7452 13.2548 32 0 32L0 24Z",
    width: "24",
    height: "56"
  }
};

export {
  cornerConfig
};
//# sourceMappingURL=chunk-ZHEFC5DU.mjs.map